import axios from "axios";

import { fullAPIURL } from "../../utils/requests";
import { refreshAccessTokenInterceptor } from "../../utils/refreshTokens";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../../utils/axios.utils";

const axiosInstance = axios.create({
  baseURL: `${fullAPIURL}/v2`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

axiosInstance.interceptors.request.use(requestAccessTokenInterceptor);
axiosInstance.interceptors.request.use(refreshAccessTokenInterceptor);
axiosInstance.interceptors.response.use(responseStatusInterceptor);

export type SuggestionsResponse = {
  suggestions: string[];
};

export async function getSuggestions(): Promise<string[]> {
  const url = `/ai/committed-club-name-suggestions`;
  const response = await axiosInstance.get<SuggestionsResponse>(url);
  return response.data.suggestions;
}
